type TokenPayload = { activeTenantId?: string | null; exp?: number };

/** Il payload del token di sessione in localStorage, o `null` se manca o non è leggibile. */
export function readTokenPayload(): TokenPayload | null {
  try {
    const payload = localStorage.getItem('token')?.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64)) as TokenPayload;
  } catch {
    return null;
  }
}

/** Il tenant attivo nel token di sessione, stringa vuota se non ce n'è uno. */
export function readActiveTenantId(): string {
  return readTokenPayload()?.activeTenantId || '';
}

/** Se il token della sessione ha un tenant attivo: senza, il backend non ha dati del tenant da restituire. */
export function hasActiveTenantSession(): boolean {
  return Boolean(readActiveTenantId());
}
